export default __webpack_public_path__ + "static/media/oppa_sheet.12b3c302.png";